function getSearchParameter(parameter: string) {
  const { search } = window.location;

  const searchParams = new URLSearchParams(search);

  return searchParams.get(parameter) ?? null;
}

export { getSearchParameter };
